import { useAcl } from "vue-simple-acl";
import { ACLRoles } from "~/core/models/ACLRoles.enum";
import type { GenericParameters } from "~/core/models/GenericParameters.type";
import LxcError from "~/core/models/LxcError.class";
import {
  NotificationKey,
  showNotificationSuccess,
} from "~/core/utils/notifications";
import delegationService from "~/modules/relation/delegation/services/delegation.service";
import type { CreateRelationByUploadingIdCardPayload } from "~/modules/relation/models/CreateRelationByUploadingIdCardPayload.interface";

export function useDelegationUpload({ organizationCode }: GenericParameters) {
  const service =
    delegationService.createOrganizationDelegationByUploadingIdCard.bind(
      delegationService,
    );

  const error: Ref<LxcError | undefined> = ref();
  const isLoading: Ref<boolean> = ref(false);

  const { t } = useI18n();
  const { can } = useAcl();

  const showUploadIdCardModal = ref(false);

  async function uploadIdCard({
    file,
    progress,
  }: CreateRelationByUploadingIdCardPayload): Promise<void> {
    isLoading.value = true;
    error.value = undefined;

    const response = await service({
      organizationCode,
      upload: { file, progress },
    });

    if (LxcError.check(response)) {
      error.value = response;
      error.value.notify(NotificationKey.uploadError);
    } else {
      showNotificationSuccess(t(NotificationKey.saveSuccess));
    }
    isLoading.value = false;
    showUploadIdCardModal.value = false;
  }

  function canCreateDelegationByUploadingIdCard() {
    return can(ACLRoles.CAN_WRITE_RELATION);
  }

  return {
    isLoading,
    error,
    showUploadIdCardModal,
    canCreateDelegationByUploadingIdCard,
    uploadIdCard,
  };
}
